var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemps2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.95 26.3398H158.26V32.2599H175.95V26.3398Z",
    fill: "#F97E73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.75 25.6298V30.6997C197.84 30.3897 199.13 30.2197 200.78 30.2197C204.56 30.2197 207.28 31.5997 207.28 34.1997C207.28 36.7997 205.14 37.9998 200.92 37.9998C197.94 37.9998 193.91 37.3198 190.85 35.7498L190.03 42.4697C193.11 43.8997 197.36 44.8197 201.48 44.8197C208.76 44.8197 215.45 42.3197 215.45 34.4597C215.45 29.1297 211.23 25.5597 205.51 25.0997L213.83 17.1897V11.3896H191.63V18.2598H204.1L196.75 25.6298Z",
    fill: "#F97E73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.43 238.93L34.5701 162.55L34.7701 22.4998L166.62 98.8698L166.43 238.93Z",
    fill: "#B2E8C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.56 143.5L34.71 67.1198L34.77 22.4998L166.62 98.8698L166.56 143.5Z",
    fill: "#B2E8C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7402 103.84L44.9402 91.2097L44.9702 70.1298L66.7701 82.7598L66.7402 103.84Z",
    fill: "#29A063"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.57 121.12L74.77 108.49L74.8 87.4097L96.6 100.04L96.57 121.12Z",
    fill: "#29A063"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.41 138.4L104.61 125.77L104.64 104.7L126.44 117.32L126.41 138.4Z",
    fill: "#29A063"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.25 155.68L134.44 143.05L134.47 121.98L156.28 134.6L156.25 155.68Z",
    fill: "#29A063"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7001 130.65L44.9001 118.02L44.9302 96.9397L66.7302 109.57L66.7001 130.65Z",
    fill: "#29A063"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M96.54 147.93L74.73 135.3L74.7599 114.22L96.5699 126.85L96.54 147.93Z",
    fill: "#29A063"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M126.37 165.21L104.57 152.58L104.6 131.5L126.4 144.13L126.37 165.21Z",
    fill: "#29A063"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.21 182.49L134.4 169.86L134.43 148.78L156.24 161.41L156.21 182.49Z",
    fill: "#29A063"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6701 157.46L44.8601 144.83L44.8901 123.75L66.7001 136.38L66.6701 157.46Z",
    fill: "#29A063"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5002 174.74L74.7002 162.11L74.7202 141.03L96.5302 153.66L96.5002 174.74Z",
    fill: "#29A063"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.33 192.02L104.53 179.39L104.56 158.31L126.36 170.94L126.33 192.02Z",
    fill: "#29A063"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M182.94 89.4597L166.62 98.8698L166.43 238.93L182.74 229.51L182.94 89.4597Z",
    fill: "#29A063"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.08 13.0796L34.77 22.4996L166.62 98.8696L182.94 89.4596L51.08 13.0796Z",
    fill: "#72D09A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M135.4 112.9C130.17 109.87 125.92 102.5 125.93 96.4596L125.95 80.4496C125.95 77.4296 127.02 75.3096 128.74 74.3296C130.46 73.3396 132.83 73.4896 135.45 74.9996C140.68 78.0296 144.93 85.3996 144.92 91.4396L144.9 107.45C144.9 110.47 143.83 112.58 142.11 113.57C140.39 114.56 138.01 114.41 135.4 112.9Z",
    fill: "#72D09A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M172.09 75.7597C172.09 69.7297 167.85 62.3496 162.62 59.3196C160 57.7996 157.62 57.6595 155.9 58.6495L134.19 71.1996L128.74 74.3296C130.46 73.3396 132.83 73.4896 135.45 74.9996C140.68 78.0296 144.93 85.3996 144.92 91.4396L144.9 107.45C144.9 110.47 143.83 112.58 142.11 113.57L147.57 110.43C149.29 109.44 150.36 107.32 150.36 104.31L150.38 88.3096V89.4396L166.68 80.0195L172.09 83.1596V76.8995V75.7695V75.7597Z",
    fill: "#29A063"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0001 66.3696C49.7701 63.3396 45.53 55.9696 45.53 49.9396L45.55 33.9296C45.55 30.9096 46.62 28.7896 48.34 27.8096C50.06 26.8196 52.43 26.9696 55.05 28.4796C60.28 31.5096 64.53 38.8796 64.52 44.9196L64.5001 60.9296C64.5001 63.9396 63.43 66.0596 61.71 67.0496C59.99 68.0396 57.6101 67.8897 55.0001 66.3797V66.3696Z",
    fill: "#72D09A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2201 12.7896C79.6001 11.2696 77.2201 11.1297 75.5001 12.1197L53.7901 24.6696L48.3401 27.7996C50.0601 26.8096 52.4301 26.9597 55.0501 28.4697C60.2801 31.4997 64.5301 38.8696 64.5201 44.9096L64.5001 60.9196C64.5001 63.9296 63.4301 66.0496 61.7101 67.0396L67.1701 63.8996C68.8901 62.9096 69.9501 60.7896 69.9601 57.7796L69.9801 42.8996L86.2801 33.4797L91.6901 36.6396V29.2097C91.7001 23.1797 87.4501 15.7996 82.2201 12.7696V12.7896Z",
    fill: "#29A063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemps2);
export default __webpack_public_path__ + "static/media/temps2.a0b45e92c3427d2205eb9222eb78623f.svg";
export { ForwardRef as ReactComponent };